import { render, staticRenderFns } from "./SMSTemplateForm.vue?vue&type=template&id=592d4d1d&scoped=true&"
import script from "./SMSTemplateForm.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./SMSTemplateForm.vue?vue&type=style&index=0&id=592d4d1d&scoped=true&lang=css&"
import style1 from "./SMSTemplateForm.vue?vue&type=style&index=1&id=592d4d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d4d1d",
  null
  
)

export default component.exports